export default __webpack_public_path__ + "static/media/banner-add-card.e25b9cb5.png";